import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'

import { OpenConfirmation } from '@/store'

export const getLeaveAction = (id: ID) =>
  OpenConfirmation({
    label: 'Confirm',
    message:
      'You will lose access to the team space and its advanced features.',
    title: 'Leave team',
    then: [DashboardActions.members.leaveTeam({ workspaceId: id })],
  })
